import { useRef } from "react";

import { createOperatorEntityId } from "@lib/agenticAi/createOperatorEntityId";

/**
 * Returns an id for an Operator registration that is unique in the page and stable for the
 * life of the mount. Use it for every `toolEntityId` (or tool name) a component generates;
 * Beacon's `useId` is random and can repeat.
 *
 * @param prefix Identifies the kind of control, for example "braze-icon-button"
 * @returns The id
 */
export const useOperatorEntityId = (prefix: string): string => {
  const idRef = useRef<string>();
  if (idRef.current === undefined) {
    idRef.current = createOperatorEntityId(prefix);
  }
  return idRef.current;
};
